const imageUrl = '/image';

export default imageUrl;
